export default {
  product: {
    nameRequired: '請輸入產品名稱',
    priceRequired: '請輸入產品價格',
    pricePositive: '產品價格必須大於0',
  },
};
